export default function (editor, opt = {}) {
  const dc = editor.DomComponents;
  const defaultType = dc.getType('default');
  const defaultModel = defaultType.model;
  const defaultView = defaultType.view;

  dc.addType(opt.types.card, {
    model: defaultModel.extend(
      {
        defaults: Object.assign({}, defaultModel.prototype.defaults, {
          'custom-name': opt.labels.card,
          resizable: true,
          classes: ['card'],
          traits: [].concat(defaultModel.prototype.defaults.traits),
        }),
      },
      {
        isComponent(el) {
          if (el.getAttribute && el.getAttribute('data-gjs-type') === opt.types.card) {
            return { type: opt.types.card };
          }
        },
      },
    ),
    view: defaultView,
  });
  dc.addType(opt.types.card_body, {
    model: defaultModel.extend(
      {
        defaults: Object.assign({}, defaultModel.prototype.defaults, {
          'custom-name': opt.labels.card_body,
          classes: ['card-body'],
          traits: [
            {
              type: 'class_select',
              label: 'Text Theme',
              options: [
                { value: '', name: 'Default' },
                {
                  value: 'text-white',
                  name: 'White',
                },
                {
                  value: 'text-primary',
                  name: 'Primary',
                },
                {
                  value: 'text-secondary',
                  name: 'Secondary',
                },
                {
                  value: 'text-success',
                  name: 'Success',
                },
                {
                  value: 'text-danger',
                  name: 'Danger',
                },
                {
                  value: 'text-warning',
                  name: 'Warning',
                },
                {
                  value: 'text-info',
                  name: 'Info',
                },
                {
                  value: 'text-dark',
                  name: 'Dark',
                },
              ],
            },
          ].concat(defaultModel.prototype.defaults.traits),
        }),
      },
      {
        isComponent(el) {
          if (el.getAttribute && el.getAttribute('data-gjs-type') === opt.types.card_body) {
            return { type: opt.types.card_body };
          }
        },
      },
    ),
    view: defaultView,
  });
  dc.addType(opt.types.card_header, {
    model: defaultModel.extend(
      {
        defaults: Object.assign({}, defaultModel.prototype.defaults, {
          'custom-name': opt.labels.card_header,
          classes: ['card-header'],
          traits: [
            {
              type: 'class_select',
              label: 'Background',
              options: [
                { value: '', name: 'Default' },
                {
                  value: 'bg-transparent',
                  name: 'Transparent',
                },
              ],
            },
          ].concat(defaultModel.prototype.defaults.traits),
        }),
      },
      {
        isComponent(el) {
          if (el.getAttribute && el.getAttribute('data-gjs-type') === opt.types.card_header) {
            return { type: opt.types.card_header };
          }
        },
      },
    ),
    view: defaultView,
  });
  dc.addType(opt.types.card_footer, {
    model: defaultModel.extend(
      {
        defaults: Object.assign({}, defaultModel.prototype.defaults, {
          'custom-name': opt.labels.card_footer,
          classes: ['card-footer'],
          traits: [
            {
              type: 'class_select',
              label: 'Background',
              options: [
                { value: '', name: 'Default' },
                {
                  value: 'bg-transparent',
                  name: 'Transparent',
                },
              ],
            },
          ].concat(defaultModel.prototype.defaults.traits),
        }),
      },
      {
        isComponent(el) {
          if (el.getAttribute && el.getAttribute('data-gjs-type') === opt.types.card_footer) {
            return { type: opt.types.card_footer };
          }
        },
      },
    ),
    view: defaultView,
  });
}
